<div class="dry-run-report">
    <clr-spinner
        *ngIf="!isReportLoaded"
        clrInline
    ></clr-spinner>

    <system-report-summary-card
        *ngIf="isReportLoaded"
        [systemReportName]="systemReportName"
        [systemReportStartAndEndTime]="systemReportStartAndEndTime"
        [systemReadinessSummaryDetails]="systemReadinessSummaryDetails"
        [dryRunSummaryDetails]="dryRunSummaryDetails"
        [systemTaskDetails]="systemTaskDetails"
    ></system-report-summary-card>
</div>
